export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/combination-provider-arrow-middle.be6e23e2-f94b50.svg";